import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('issued-items-file-activity-list')
export class IssuedItemsFileActivityList extends LitElement {
    render() {
        return html`<div>Issued Items File Activity List</div>`;
    }
}
